export class LoginResponse {
	id: number;
	username: string;
	authority: string; 
	token: string;
	passwordExpiryMessageIfAny: string;
	color: string;
}